var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onGlobalClick}},[_c('header-component'),_c('router-view',{key:_vm.selectedAspectInstanceId}),_c('notification-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }